// AdminLayout — the project "admin" frame. A pathless layout route grouping the
// admin pages at flat URLs (no /admin/ segment — ADR-018: module names never in
// URLs; "admin mode" is a layout, not a URL). The gear navigates to the first
// allowed admin page (e.g. /p/:projectId/users), which renders in here.
//
// Adds the only meaningful extra chrome over the domain frame: the left
// AdminSidebar (section nav). The top bar + <main> landmark stay in
// AuthedLayout; the AdminSidebar <nav> + the content sit inside that main.

import { Outlet } from 'react-router-dom';
import { useProjectParams } from '../../hooks/useProjectParams.js';
import { AdminSidebar } from './AdminSidebar.js';
import { PeekHost } from './PeekHost.js';
import { pageBox, pageGutter } from './pageBox.js';

export function AdminLayout() {
  const projectId = useProjectParams();
  // Rail + content sit inside the shared `pageBox` (the boxed app frame). The
  // rail is FLUSH to the box's left edge (= the topbar band's left edge), so
  // there's no void; the content carries the gutter. On ultra-wide the whole
  // unit caps with calm canvas wings (DESIGN-TOKENS §Content measure).
  return (
    <div className={`${pageBox} flex flex-1 items-stretch min-w-0`}>
      <AdminSidebar projectId={projectId} />
      <div className={`flex-1 min-w-0 ${pageGutter} py-6`}>
        <Outlet />
      </div>
      {/* Global entity-peek host (ADR-036 §2) — renders the peek from ?peek=type:id
          so any admin page opens one without coupling. */}
      <PeekHost projectId={projectId} />
    </div>
  );
}
